export default __webpack_public_path__ + "static/media/P330MANA6.264d41af.pdf";